import { PenaltyDescriptionId } from '@/warranty/domain/entities/penalty-description-id';
import type { PenaltyOverview } from '@/warranty/domain/entities/penalty-overview';

export interface PenaltyOverviewRow {
  'platform_core_warranty_penalty_unit_alerts.description_id': string;
  'platform_core_warranty_penalty_unit_alerts.extreme_value_agg': number;
  'platform_core_warranty_penalty_unit_alerts.value_unit': string;
  'platform_core_warranty_penalty_unit_alerts.last_detection_historical':
    | string
    | null;
  'platform_core_warranty_penalty_unit_alerts.duration_h_historical_agg': number;
  'platform_core_warranty_penalty_unit_alerts.count_historical_agg': number;
  'platform_core_warranty_penalty_unit_alerts.penalty_historical_agg': number;
}

export function transformPenaltyOverview(
  result: PenaltyOverviewRow,
): PenaltyOverview {
  const lastDetectionValue =
    result[
      'platform_core_warranty_penalty_unit_alerts.last_detection_historical'
    ];

  return {
    id: result['platform_core_warranty_penalty_unit_alerts.description_id'],
    groupFullId: '',
    topFullId: '',
    unitFullId: '',
    fullFrontendId: '',
    description: result[
      'platform_core_warranty_penalty_unit_alerts.description_id'
    ] as PenaltyDescriptionId,
    extremeValue:
      result['platform_core_warranty_penalty_unit_alerts.extreme_value_agg'],
    unit: result['platform_core_warranty_penalty_unit_alerts.value_unit'],
    latestDetect: lastDetectionValue
      ? new Date(lastDetectionValue)
      : new Date(0),
    duration:
      result[
        'platform_core_warranty_penalty_unit_alerts.duration_h_historical_agg'
      ],
    totalCount:
      result['platform_core_warranty_penalty_unit_alerts.count_historical_agg'],
    sohPenalty:
      result[
        'platform_core_warranty_penalty_unit_alerts.penalty_historical_agg'
      ],
  };
}
